// Standard library imports
import React, { useEffect, useState } from 'react';

// External library imports
import { toast } from 'react-toastify';
import { get as lodashGet } from 'lodash';
import { UilTrash } from '@iconscout/react-unicons';

// Internal module imports
import { RootBiddingService } from '../../../../../services/BiddingService/Root/BiddingService';
import { momentTimeFormater } from '../../../../../utils/dateHelper';
import { useLoader, useUserRole } from '../../../../../hooks';
import bidClasses from '../../Bidding.module.css';
import DeleteModal from '../../../../../components/DeleteModal/DeleteModal';
import IconComponent from '../../../../../components/Icon/Icon';
import allDeviceClasses from '../../../../../styles/AllDevices.module.css';
import { CreateNote } from './CreateNote';
import ModalComponent from '../../../../../components/ModalComponent/ModalComponent';
import { AdminBiddingService } from '../../../../../services/BiddingService/Admin/BiddingService';
import { RootBundleBiddingService } from '../../../../../services/BiddingService/Root/BundleBiddingService';
import { AdminBundleBiddingService } from '../../../../../services/BiddingService/Admin/BundleBiddingService';

export const Notes = ({ bid, closeModal, bidType }) => {
    const { isRootUser } = useUserRole();
    const service = isRootUser ? (bidType === 'bundle' ? RootBundleBiddingService : RootBiddingService) : bidType === 'bundle' ? AdminBundleBiddingService : AdminBiddingService;
    const [startLoader, stopLoader] = useLoader();
    const [notes, setNotes] = useState([]);
    const [createModal, setCreateModal] = useState({ status: false });
    const [deleteModal, setDeleteModal] = useState({
        status: false,
        id: null,
        note_id: null,
    });

    useEffect(() => {
        if (bid._id) getNotes();
    }, [bid]);

    const getNotes = () => {
        service.GetNotes(bid._id, startLoader, handleGetSuccess, handleError, stopLoader);
    };

    const handleGetSuccess = ({ data }) => {
        const processed = data.data.map((item) => ({
            description: item.description,
            date: momentTimeFormater(item.date).format('YYYY-MM-DD'),
            user: item?.userName || '--',
            note_id: item._id,
        }));
        setNotes(processed);
    };

    const handleDelete = () => {
        const params = { noteId: deleteModal.note_id };
        service.DeleteNote(deleteModal.id, params, startLoader, handleDeleteSuccess, handleError, stopLoader);
    };

    const handleDeleteSuccess = () => {
        toast.success('Note deleted!');
        getNotes();
    };

    const handleError = (err) => {
        toast.error(lodashGet(err, ['response', 'data', 'message']));
    };

    return (
        <div>
            <div className={bidClasses.LogsModalContainer}>
                <div className={bidClasses.Flex} style={{ justifyContent: 'flex-end' }}>
                    <div>
                        <div onClick={() => setCreateModal({ status: true })}>
                            <button className="btn-primary" style={{ marginTop: 0 }}>
                                Create Note
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <div className={bidClasses.CardsContainer}>
                        {notes.map((note, key) => (
                            <div className={bidClasses.Card} key={key}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <div className={bidClasses.SubTitleWrapper}>
                                        <div className={bidClasses.SubTitle}>Created By: {note.user}</div>
                                        <div className={bidClasses.SubTitle}>Created At: {note.date}</div>
                                    </div>
                                    <div
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setDeleteModal({
                                                status: true,
                                                id: bid._id,
                                                note_id: note.note_id,
                                            });
                                        }}
                                    >
                                        <IconComponent icon={UilTrash} tooltip={'Delete'} />
                                    </div>
                                </div>

                                <div className={bidClasses.Content}>
                                    <span>{note.description}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className={allDeviceClasses.ButtonContainer}>
                    <div>
                        <button type="button" className="btn-secondary" onClick={() => closeModal()}>
                            Close
                        </button>
                    </div>
                </div>
            </div>

            {createModal.status && (
                <ModalComponent isOpen={createModal.status} setOpen={() => setCreateModal({ status: false })}>
                    <CreateNote bid={bid} setOpen={setCreateModal} getNotes={getNotes} bidType={bidType} />
                </ModalComponent>
            )}
            <DeleteModal deletefunction={handleDelete} opendeleteModal={deleteModal.status} setOpenDeleteModal={(status) => setDeleteModal({ id: null, status, note_id: null })} />
        </div>
    );
};
